import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logo from "../assets/duck-images/duck-logo.png"

import twitter from "../assets/duck-images/twitter-x-logo.png"
import twitter2 from "../assets/duck-images/x-icon.svg"

import { ReactComponent as Twitter } from '../assets/duck-images/x-icon.svg';

import { IoWalletOutline, IoWallet } from "react-icons/io5"
import { HiBars3BottomRight } from "react-icons/hi2"
import { FaTwitter, FaTelegramPlane } from "react-icons/fa"

import TooltipComponent from "./tooltip"
import Modal from "./modal"



function Navbar({ ConnectWalletFunc, isConnect, setIsConnect, disconnectWallet }) {
    // const [wallet, setWallet] = useState(1);


    // Modal
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container">
                    <a className="navbar-brand" href="/">
                        <img src={logo} alt="logo" className='img-fluid' />
                    </a>
                    <div className='d-flex align-items-center'>
                        <button className="navbar-toggler mx-3" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <HiBars3BottomRight className='toggler_icon' />
                        </button>
                        <div className="asd3">
                            {
                                isConnect.length === 0 ?
                                    <TooltipComponent className="wallet_btn" placement="bottom" tooltipText="Connect Wallet">
                                        <div> <IoWalletOutline className='wallet_btn' onClick={ConnectWalletFunc} /> </div>
                                    </TooltipComponent>
                                    :
                                    <>
                                        <div onClick={handleShow}> <IoWallet className='wallet_btn' /> {isConnect?.substring(0, 10) + "..."} </div>
                                        <div>
                                            <Modal heading="Do you want to Disconnect Wallet?" show={show} handleShow={handleShow} handleClose={handleClose}>
                                                <div style={{ textAlign: "center" }}>
                                                    <button className="btn btn-secondary" onClick={handleClose}>No, I don't want</button>
                                                    &nbsp; &nbsp; &nbsp;
                                                    <button className="btn btn-primary" onClick={() => { disconnectWallet(); handleClose() }}>Yes, I want to</button>
                                                </div>
                                            </Modal>
                                        </div>
                                    </>
                            }
                        </div>
                    </div>


                    <div className="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
                        <ul className="navbar-nav mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link active" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/farm">The Farm</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/token">Token</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/defi">DeFi</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="https://whitepaper.duckduckgoosegame.xyz/" target='_blank'>Whitepaper</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="/contact">Contact</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active " to="https://twitter.com/duck_goose_game" target='_blank'>
                                    <img src={twitter2} alt="icon" className='img-fluid twitter-icon' />
                                    {/* <FaTwitter /> */}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active" to="https://t.me/duckduckgoosegame" target='_blank'>
                                    <FaTelegramPlane />
                                </Link>
                            </li>
                            {/* <li className="nav-item dropdown">
                                <a className="nav-link active dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Follow
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><Link className="dropdown-item" to="#">Twitter</Link></li>
                                    <li><Link className="dropdown-item" to="#">Instagram</Link></li>
                                    <li><Link className="dropdown-item" to="#">Discord</Link></li>
                                </ul>
                            </li> */}
                            <li className="nav-item">
                                <div className='button res_btn d-none'>
                                    <a href="#" className='btn' style={{ paddingBottom: "12px", borderRadius: "10px" }}>
                                        <div>Get Started</div>
                                        <div className='button-bg' style={{ backgroundColor: "transparent" }}></div>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className='button'>
                        {
                            isConnect.length === 0 ?
                                <button onClick={ConnectWalletFunc} className='btn' style={{ paddingBottom: "12px", borderRadius: "10px" }}>
                                    <div><IoWalletOutline className='mx-1' style={{ fontSize: "25px" }} />Connect Wallet</div>
                                    <div className='button-bg' style={{ backgroundColor: "transparent" }}></div>
                                </button>
                                :
                                <>
                                    <button className='btn' onClick={handleShow} style={{ paddingBottom: "12px", borderRadius: "10px" }}>
                                        <div><IoWalletOutline className='mx-1' style={{ fontSize: "25px" }} />{isConnect.substring(0, 10) + "..."}</div>
                                        <div className='button-bg' style={{ backgroundColor: "transparent" }}></div>
                                    </button>

                                    {/* <div > <IoWallet className='wallet_btn' /> {isConnect?.substring(0, 10) + "..."} </div> */}
                                    <div>
                                        <Modal heading="Do you want to Disconnect Wallet?" show={show} handleShow={handleShow} handleClose={handleClose}>
                                            <div style={{ textAlign: "center" }}>
                                                <button className="btn btn-secondary" onClick={handleClose}>No, I don't want</button>
                                                &nbsp; &nbsp; &nbsp;
                                                <button className="btn btn-primary" onClick={() => { disconnectWallet(); handleClose() }}>Yes, I want to</button>
                                            </div>
                                        </Modal>
                                    </div>
                                </>

                        }
                    </div>
                </div>
            </nav>
        </>
    )
}


export default Navbar